'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertTriangle, FeatherCheckCircle, FeatherClock, FeatherSend, FeatherXCircle } from '@subframe/core';
import { StatsCard } from '@/shared/components/ui';
import type { FaturaListSummary } from '../types';
import { formatarMoedaBR } from '../utils/faturaFormatters';
interface FaturaListSummaryCardsProps {
  summary: FaturaListSummary;
}
export function FaturaListSummaryCards(t0) {
  const $ = _c(29);
  const {
    summary
  } = t0;
  let t1;
  if ($[0] !== summary.totalEmitido) {
    t1 = formatarMoedaBR(summary.totalEmitido);
    $[0] = summary.totalEmitido;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FeatherSend className="text-brand-600" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <StatsCard label={"Emitido no per\xEDodo"} value={t1} icon={t2} />;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== summary.totalPago) {
    t4 = formatarMoedaBR(summary.totalPago);
    $[5] = summary.totalPago;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherCheckCircle className="text-success-600" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <StatsCard label="Pago" value={t4} icon={t5} />;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== summary.totalAReceber) {
    t7 = formatarMoedaBR(summary.totalAReceber);
    $[10] = summary.totalAReceber;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FeatherClock className="text-warning-600" />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7) {
    t9 = <StatsCard label="A receber" value={t7} icon={t8} />;
    $[13] = t7;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== summary.totalVencido) {
    t10 = formatarMoedaBR(summary.totalVencido);
    $[15] = summary.totalVencido;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <FeatherAlertTriangle className="text-error-600" />;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10) {
    t12 = <StatsCard label="Vencido" value={t10} icon={t11} />;
    $[18] = t10;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <FeatherXCircle className="text-error-600" />;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== summary.quantidadeComErroEmissao) {
    t14 = <StatsCard label={"Com erro de emiss\xE3o"} value={summary.quantidadeComErroEmissao} icon={t13} />;
    $[21] = summary.quantidadeComErroEmissao;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t12 || $[24] !== t14 || $[25] !== t3 || $[26] !== t6 || $[27] !== t9) {
    t15 = <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-5">{t3}{t6}{t9}{t12}{t14}</div>;
    $[23] = t12;
    $[24] = t14;
    $[25] = t3;
    $[26] = t6;
    $[27] = t9;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  return t15;
}